import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DropdownField, useControlledField } from '@frontend/design-system';
import { AxisOption } from './types';

export interface XAxisSelectorProps {
  options: AxisOption[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export const XAxisSelector = ({ options, value, onChange, label = '' }: XAxisSelectorProps) => {
  const fieldProps = useControlledField({
    type: 'dropdown',
    value,
    onChange,
  });

  return (
    <DropdownField
      {...fieldProps}
      name='x-axis-selector'
      label={label}
      dropdownListStyle={css`
        font-size: ${theme.fontSize(14)};
      `}
      css={css`
        min-width: 140px;
        height: 32px;
        p {
          font-size: ${theme.fontSize(14)};
        }
      `}
    >
      {options.map((option) => (
        <DropdownField.Option key={option.value} value={option.value}>
          {option.label}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};
